import React from "react";
import Icon from "./Icon";

const VARIANT_CLASSES = {
  accent: [
    "bg-brand-accent",
    "text-on-brand",
    "hover:bg-brand-accent-hover",
    "active:bg-brand-accent",
  ].join(" "),
  control: [
    "bg-control-bg",
    "text-primary",
    "border border-control-border",
    "hover:border-secondary",
  ].join(" "),
  "accent-faded": [
    "bg-brand-accent-faded",
    "text-brand-accent-fg",
    "hover:bg-brand-accent",
    "hover:text-on-brand",
  ].join(" "),
  "danger-faded": [
    "bg-danger-faded",
    "text-danger-fg",
    "hover:bg-danger",
    "hover:text-on-danger",
  ].join(" "),
  ghost: [
    "bg-transparent",
    "text-brand-accent-fg",
    "shadow-none",
    "hover:bg-brand-accent-faded",
  ].join(" "),
  "ghost-icon": [
    "bg-transparent",
    "text-primary",
    "shadow-none",
    "hover:text-brand-accent-fg",
  ].join(" "),
};

const BASE_CLASSES = [
  "inline-flex",
  "items-center",
  "justify-center",
  "box-border",
  "select-none",
  "gap-2",
  "border-0",
  "appearance-none",
  "min-w-[64px]",
  "rounded-sm",
  "px-5",
  "py-2",
  "text-sm",
  "capitalize",
  "font-sans",
  "font-normal",
  "leading-[1.5]",
  "shadow-material",
  "overflow-hidden",
  "cursor-pointer",
  "transition-colors",
  "duration-150",
  "disabled:bg-disabled-bg",
  "disabled:text-disabled-text",
  "disabled:cursor-default",
  "disabled:shadow-none",
  "focus-visible:outline-2",
  "focus-visible:outline-offset-2",
  "focus-visible:outline-info-fg",
].join(" ");

function Button({
  variant = "accent",
  icon = null,
  iconSize = "sm",
  children = null,
  disabled = false,
  className = "",
  onClick,
  type = "button",
  id,
  title,
  style,
  "aria-label": ariaLabelProp,
  ariaLabel,
  ...props
}) {
  const accessibleName =
    ariaLabelProp ||
    ariaLabel ||
    (typeof children === "string" ? children : undefined) ||
    title ||
    undefined;

  const classes = [BASE_CLASSES, VARIANT_CLASSES[variant], className]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      id={id}
      type={type}
      title={title}
      aria-label={accessibleName}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      style={style}
      {...props}
    >
      {icon ? <Icon name={icon} size={iconSize} /> : null}
      {children ? <span className="pointer-events-none">{children}</span> : null}
    </button>
  );
}

export default Button;